/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react'

const Invoices = () => {
    var CryptoJS = require("crypto-js");
    return (
        <div className='details_component_overall'> 

        </div>
    )
}

export default Invoices